import { render, staticRenderFns } from "./ComingSoonView.vue?vue&type=template&id=a96caa1a&scoped=true&"
import script from "./ComingSoonView.vue?vue&type=script&lang=js&"
export * from "./ComingSoonView.vue?vue&type=script&lang=js&"
import style0 from "./ComingSoonView.vue?vue&type=style&index=0&id=a96caa1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a96caa1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFooter } from 'vuetify/lib/components/VFooter';
import { VImg } from 'vuetify/lib/components/VImg';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VFooter,VImg,VProgressLinear,VRow})
